import moment from 'moment';
import { formatMoney, mergeTimeSeriesForTables, processTimeSeries } from '../../utils';
import { offerTypes } from './actions';



let createNewOffer = () => {
    return {
        timeSeries: {},
        parameters: {
            start: null,
            end: null,
            length: null,
            // payment: null,
        },
        keyFigures: {
            'Betrag': {},
            'Wert': {},
        },
        tableTimeSeries: [],
        isFetching: true,
        error: false,
    }
}


const initialState = {
    offers: {},
    offerQueryParameters: {},
    contractSigning: {},
    isStale: true
}


export function offers(state = initialState, action) {

    switch(action.type) {

        case offerTypes.SET_STATE_MULTI:
            state = {...state}
            if (state.offerQueryParameters[action.customerId] === undefined) {
                state.offerQueryParameters[action.customerId] = {}
            }
            for(let item of action.data) {
                if (item.value === true) {
                    state.offerQueryParameters[action.customerId][item.key] = item.value
                } else {
                    delete state.offerQueryParameters[action.customerId][item.key]
                    try {
                        delete state.offers[action.customerId][item.key]
                    } catch(e) {}
                }
            }
            return state;
        case offerTypes.TOGGLE_TYPE:
            state = {...state}
            for (let customer of action.customerIds) {
                if (state.offerQueryParameters[customer] === undefined) {
                    state.offerQueryParameters[customer] = {}
                }
    
                if (Object.keys(state.offerQueryParameters[customer]).includes(action.insuranceType)) {
                    delete state.offerQueryParameters[customer][action.insuranceType]
                    try {
                        delete state.offers[customer][action.insuranceType]
                    } catch(e) {}
                } else {
                    state.offerQueryParameters[customer][action.insuranceType] = true
                }
            }
            return state

        case offerTypes.SET_STALE:
          state = {
            ...state, 
            isStale: action.isStale,
        }
        return state

        case offerTypes.REQUEST:
            state = {...state}
            let newoffer = createNewOffer()
            
            if (state.offers[action.customerId] === undefined) {
                state.offers[action.customerId] = {
                    [action.offerType]: newoffer,
                }
            } else {
                state.offers[action.customerId][action.offerType] = newoffer
            }
            return state

        case offerTypes.CLEAR_PERSON:
            state = { ...state }

            if (Object.keys(state.offerQueryParameters).includes(action.customerId)) {
                delete state.offerQueryParameters[action.customerId]
            }
            if (Object.keys(state.offers).includes(action.customerId)) {
                delete state.offers[action.customerId]
            }

            return state

        case offerTypes.ERROR:
            state = {
                ...state,
                isFetching: false,
            }

            let _offer = Object.assign({}, state.offers[action.customerId][action.offerType])
            _offer.error = true
            _offer.isFetching = false
            _offer.errorMessage = "Ekki næst samband við vefþjónustu Unfall/Leben/Allianz á Íslandi. Vinsamlegast reynið aftur síðar og hafið samband við skrifstofu Allianz ef þetta er viðvarandi vandamál."

            if (state.offers[action.customerId] === undefined) {
                state.offers[action.customerId] = {
                    [action.offerType]: _offer,
                }
            } else {
                state.offers[action.customerId][action.offerType] = _offer
            }


            return state

        case offerTypes.RECEIVE:
            state = {
                ...state, 
                isFetching: false,
            }

            let offer = Object.assign({}, state.offers[action.customerId][action.offerType])

            offer.isFetching = false

            offer.data = action.data

            if (!["00000", "00003"].includes(action.data.Angebot.Status.StatusID) && action.offerType !== "RIS") {
                offer.error = true
                offer.errorMessage = "Vefþjónusta Allianz skilaði villu, vinsamlegast farið yfir forsendur, reynið aftur og hafið samband við skrifstofu Allianz ef þetta er viðvarandi vandamál."
                console.log(`%cError #${action.data.Angebot.Status.Meldung.MeldungID}\n${action.data.Angebot.Status.Meldung.Text}`, [
                    'color: yellow',
                    'background: red',
                    'font-size: 14px',
                    'border: 1px solid red',
                    'padding: 10px',
                  ].join(';'))

                let Meldung = action.data.Angebot.Status.Meldung
                if (Meldung.length > 1) {
                    Meldung = Meldung[0]
                }

                if (Meldung.Text.startsWith("Mit den Vorgaben war keine Berechnung möglich.")) {
                    let matches = Meldung.Text.match(/Beitrag ([\d\.]+)/gi)
                    if (matches) {
                        let amount = matches[0]
                        amount = amount.replace("Beitrag ", "")
                        if (amount[amount.length] === ".") {
                            amount = amount.substr(0, amount.length-1)
                            amount = amount.replace(".", ",")
                        }
                        offer.errorMessage = `Ekki er hægt að reikna tilboðið miðað við þessar forsendur. Vinsamlegast reynið aftur með iðgjaldi sem er ekki lægra en ${amount} €`
                        let matches2 = Meldung.Text.match(/Kap. b. Unfall ([\d\.]+)/gi)
                        if (matches2) {
                            let amount2 = matches2[0]
                            amount2 = amount2.replace("Kap. b. Unfall ", "")
                            if (amount2[amount2.length] === ".") {
                                amount2 = amount2.substr(0, amount.length-1)
                                amount2 = amount2.replace(".", ",")
                            }
                            offer.errorMessage += ` og dánarbætur vegna slyss sem eru að minnsta kosti ${amount2} €.`
                        }
                    }
                    matches = Meldung.Text.match(/Kap. b. Unfall (\d+)%/gi)
                    if (matches) {
                        let amount = matches[0]
                        amount = amount.replace("Kap. b. Unfall ", "")
                        if (amount[amount.length] === ".") {
                            amount = amount.substr(0, amount.length-1)
                            amount = amount.replace(".", ",")
                        }
                        offer.errorMessage += ` Hlutfall dánarbóta vegna slyss má ekki fara yfir ${amount} miðað við uppgefnar forsendur.`
                    }

                    matches = Meldung.Text.match(/Kap. b. Tod (\d+)/gi)
                    if (matches) {
                        let amount = matches[0]
                        amount = amount.replace("Kap. b. Tod ", "")
                        if (amount[amount.length] === ".") {
                            amount = amount.substr(0, amount.length-1)
                            amount = amount.replace(".", ",")
                        }
                        offer.errorMessage += ` Líftrygging þarf að vera að lágmarki ${amount}€ miðað við uppgefnar forsendur.`
                    }

                } else if (Meldung.Text.startsWith("Kapital bei Unfalltod muss mindestens ")) {
                    let matches = Meldung.Text.match(/Kapital bei Unfalltod muss mindestens ([\d\.]+)/gi)
                    if (matches) {
                        let amount = matches[0]
                        amount = amount.replace("Kapital bei Unfalltod muss mindestens ", "")
                        if (amount[amount.length] === ".") {
                            amount = amount.substr(0, amount.length-1)
                            amount = amount.replace(".", ",")
                        }
                        offer.errorMessage = `Ekki er hægt að reikna tilboðið miðað við þessar forsendur. Dánarbætur v/slyss þurfa að vera ekki lægri en ${amount} €`
                }
                } else if (Meldung.Text.startsWith("Das Eintrittsalter der zu versichernden Person muss mindestens")) {
                    offer.errorMessage = "Ekki var hægt að reikna tilboðið. Dánarbætur vegna slysa eingöngu í boði fyrir 7 ára og eldri."
                }
                else if (Meldung.Text.startsWith("Ab einer Gesamtbeitragssumme von über 2,5 Mio EUR")) {
                    offer.errorMessage = "Iðgjald eða tryggingarfjárhæð er of hátt - framlag má ekki fara yfir 2.5 milljónir €"
                }
                else if (Meldung.Text.startsWith("Für die Berechnung muss eine Tätigkeit ")) {
                    offer.errorMessage = "Ekki var hægt að reikna tilboðið þar sem starf tryggingaþega var ekki tilgreint."
                }
                else if (Meldung.Text.startsWith("zulässige Werte für gar.") && action.offerType === 'KSP') {
                    let numbers = Meldung.Text.match(/[0-9]+/g)
                    offer.errorMessage = `Tekjulífeyrir þarf að vera á milli ${formatMoney(numbers[0], 0)}€ og ${formatMoney(numbers[2])}€ - vinsamlegast athugið forsendur.`
                }
                else if (Meldung.Text.startsWith("zulässige Werte für gar.") && action.offerType !== 'KSP') {
                    let numbers = Meldung.Text.match(/[0-9]+/g)
                    offer.errorMessage = `Líftryggingarfjárhæð þarf að vera á milli ${formatMoney(numbers[0], 0)}€ og ${formatMoney(numbers[2])}€ - vinsamlegast athugið forsendur.`
                }
                else if (Meldung.Text.startsWith("Kapital bei Tod muss mindestens")) {
                    let matches = Meldung.Text.match(/Kapital bei Tod muss mindestens (\d+) EUR betragen/gi)
                    if (matches) {
                        let amount = matches[0]
                        amount = amount.replace("Kapital bei Tod muss mindestens ", "")
                        amount = amount.replace(" EUR betragen", "")
                        if (amount[amount.length] === ".") {
                            amount = amount.substr(0, amount.length-1)
                            amount = amount.replace(".", ",")
                        }
                        offer.errorMessage += ` Líftrygging þarf að vera að lágmarki ${amount}€.`
                    }
                }
                else if (Meldung.Text.startsWith("Das Garantiekapital muss mindestens")) {
                    let matches = Meldung.Text.match(/Das Garantiekapital muss mindestens ([\d\.]+) EUR betragen/gi)
                    if (matches) {
                        let amount = matches[0]
                        amount = amount.replace("Das Garantiekapital muss mindestens", "")
                        amount = amount.replace(" EUR betragen", "")
                        if (amount[amount.length] === ".") {
                            amount = amount.substr(0, amount.length-1)
                            amount = amount.replace(".", ",")
                        }
                        offer.errorMessage += ` Tryggður höfuðstóll þarf að vera að lágmarki ${amount}€.`
                    }
                }
            }
            else if (!["OK"].includes(action.data.Angebot.Status.StatusID) && action.offerType === "RIS") {
                offer.error = true
                offer.errorMessage = "Villa kom upp við útreikning þessa tilboðs út frá þeim forsendum sem gefnar voru upp."
            } else {

                let paymentfrequency = null
                let mainProduct = null
                
                if (action.offerType !== "RIS") {
                    if (action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Elementarprodukt"] instanceof Array) {
                        mainProduct = action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Elementarprodukt"].find((item) => item["IstHauptversicherung"] === "true")
                    } else {
                        mainProduct = action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Elementarprodukt"]
                    }
                }

                if (mainProduct) {
                    if (mainProduct["VersicherungssummeOderLeistung"] instanceof Array) {
                        mainProduct["VersicherungssummeOderLeistung"].map((item, i) => {
                            if (typeof item["Erweiterung"] !== "undefined") {
                                offer.keyFigures[item["ArtID"]["#text"]] = item["Erweiterung"]["Ganzzahlwert"]
                            } else {
                                offer.keyFigures[item["ArtID"]["#text"]] = item["Wert"]
                            }
                        })
                    } else {
                        offer.keyFigures[mainProduct["VersicherungssummeOderLeistung"]["ArtID"]["#text"]] = mainProduct["VersicherungssummeOderLeistung"]["Wert"]
                    }
                }

                if (action.offerType == "KSP" || action.offerType == "RISLEB") {
                    offer.keyFigures["contractEnds"] = moment.utc(action.data.Angebot.Angebot.Verkaufsprodukt.Erweiterung.Ablauftermin, "YYYY-MM-DD")
                }

                let betragIndex = 0
                if (action.offerType === "RISLEB" || action.offerType === "KSP") {
                    betragIndex = 1
                }

                if (action.offerType == "RIS") {
                    offer.keyFigures["Hauptprodukt"] = action.data.Angebot["Tarifierung"]["Verkaufsprodukt"]["Produkt"]["Beitrag"][0].Betrag.Betrag
                } else {
                    offer.keyFigures["Hauptprodukt"] = action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Beitrag"][betragIndex].Betrag
                }

                
                if (action.offerType == "LEB" || action.offerType == "REN" || action.offerType == "FOR" || action.offerType == "RISLEB" || action.offerType == "KSP") {
                    let productsToLoop = []
                    if (action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Elementarprodukt"] instanceof Array) {
                        productsToLoop = action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Elementarprodukt"]
                    } else {
                        productsToLoop = [action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Elementarprodukt"]]
                    }
                    productsToLoop.map((produkt) => {
                        if (produkt.Beitrag) {
                            offer.keyFigures["Betrag"][produkt.Bezeichnung] = produkt.Beitrag[betragIndex].Betrag
                        } 
                        if (produkt.VersicherungssummeOderLeistung && produkt.VersicherungssummeOderLeistung["Wert"]) {
                            offer.keyFigures["Wert"][produkt.Bezeichnung] = produkt.VersicherungssummeOderLeistung.Wert
                        }
                        if (produkt.VersicherungssummeOderLeistung && produkt.VersicherungssummeOderLeistung instanceof Array) {
                            let wertItem = produkt.VersicherungssummeOderLeistung.filter(f => f.ArtID['#text'] === "ProzentDesGarantiekapitals")
                            if (wertItem.length > 0) {
                                offer.keyFigures["Wert"][produkt.Bezeichnung] = wertItem[0].Wert
                            } else {
                            wertItem = produkt.VersicherungssummeOderLeistung.filter(f => f.ArtID['#text'] === "Garantiekapital")
                                if (wertItem.length > 0) {
                                    offer.keyFigures["Wert"][produkt.Bezeichnung] = wertItem[0].Wert
                                }
                            }

                        }
                    })
                } else if (action.offerType == "VID" || action.offerType == "VIDT") {
                    if (mainProduct.Beitrag) {
                        offer.keyFigures["Betrag"][mainProduct.Bezeichnung] = mainProduct.Beitrag[0].Betrag
                    }
                } else if (action.offerType == "RIS" ) {
                    action.data.Angebot.Tarifierung.Verkaufsprodukt.Produkt.Elementarprodukt.map(produkt => {
                        if (produkt.VersicherungssummeOderLeistung) {
                            if (produkt.VersicherungssummeOderLeistung instanceof Array) {
                                offer.keyFigures[`${produkt.ArtID["@type"]}-${produkt.ArtID["#text"]}`] = produkt.VersicherungssummeOderLeistung[0].Wert
                            } else {
                                offer.keyFigures[`${produkt.ArtID["@type"]}-${produkt.ArtID["#text"]}`] = produkt.VersicherungssummeOderLeistung.Wert
                            }
                        } else {
                            offer.keyFigures[`${produkt.ArtID["@type"]}-${produkt.ArtID["#text"]}`] = true
                        }
                    })
                }
                

                let timeseries = {[action.customerId]: {}}
                
                if (action.offerType == "RIS") {
                    offer.parameters.start = moment.utc(action.data.Angebot.Tarifierung.Verkaufsprodukt.Produkt.Versicherungsdauer.Beginn)
                    offer.parameters.length = parseInt(action.data.Angebot.Tarifierung.Verkaufsprodukt.Produkt.Versicherungsdauer.AnzahlJahre)
                    offer.parameters.end = offer.parameters.start.clone().add(offer.parameters.length, 'years')
                } else {
                    offer.parameters.start = moment.utc(mainProduct["Beginn"])
                    offer.parameters.length = parseInt(mainProduct["Dauer"]["LaufzeitJahre"])
                    offer.parameters.end = offer.parameters.start.clone().add(offer.parameters.length, 'years')
                }
                
                if (action.offerType === "REN" || action.offerType === "FOR" || action.offerType === "VID" || action.offerType === "VIDT") {
                    // offer.parameters.payment =  mainProduct["VersicherungssummeOderLeistung"].find(item => item["ArtID"]["#text"] === "Garantiekapital")["Wert"]    
                    let theBetrag = action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Beitrag"][betragIndex]["Betrag"]
                    paymentfrequency = parseInt(action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Beitrag"][betragIndex]["Zahlungsweise"])
                    let years = parseInt(action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Beitrag"][betragIndex]["Dauer"]["LaufzeitJahre"])
                    let totalAmount = 12 * theBetrag * years
                    switch(paymentfrequency) {
                        // monthly
                        case 8:
                            break;
                        // onetime
                        case 6:
                            totalAmount = theBetrag;
                            break;
                        // quarterly
                        case 4:
                            totalAmount = 4 * theBetrag * years;
                            break;
                        // bi-yearly
                        case 2:
                            totalAmount = 2 * theBetrag * years;
                            break;
                        // yearly
                        case 1:
                            totalAmount = theBetrag * years;
                            break;
                        default:
                            break;
                    }
                    offer.parameters.payment = totalAmount
                }
                
                if (action.offerType != "RIS" && action.offerType != "KSP") {
                    timeseries[action.customerId][action.offerType] = processTimeSeries(action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Verlauf"]["Verlaufseintrag"])   
                }
                
                let amount = null
                
                if (action.offerType === "RIS") {
                    amount = action.data.Angebot.Tarifierung.Verkaufsprodukt.Produkt.Beitrag[0].Betrag.Betrag
                } else {
                    amount = action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Beitrag"][betragIndex]["Betrag"];
                    paymentfrequency = parseInt(action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Beitrag"][betragIndex]["Zahlungsweise"])
                    switch(paymentfrequency) {
                        // monthly
                        case 8:
                            break;
                        // quarterly
                        case 4:
                            amount = amount/3;
                            break;
                        // bi-yearly
                        case 2:
                            amount = amount/6;
                            break;
                        // yearly
                        case 1:
                            amount = amount/12
                            break;
                        default:
                            break;
                    }
                }

                let monthlyPayment = null
                let tableMonthlyPayment = null

                if (action.offerType !== "RIS" && action.offerType != "KSP" && action.offerType !== "RISLEB") {
                    let tariff = action.data['Angebot']['Angebot']['Verkaufsprodukt']['Produkt']['Elementarprodukt']['Bezeichnung']
                    let key = ''

                    if(action.portfolio == 'komfortdynamik'){ // KomfortDynamik
                        let hochrechnungsprozentsatz = offer.keyFigures['HochrechnungsProzentsatz5'];
                        hochrechnungsprozentsatz = hochrechnungsprozentsatz.replace('.00', '');
                        hochrechnungsprozentsatz = hochrechnungsprozentsatz.replace('.50', '.5');

                        key = `Fondswert (Todesfallleistung) mit ${hochrechnungsprozentsatz}\% Fondswertsteigerung`;
                        if(Array.isArray(action.data['Angebot']['Angebot']['Verkaufsprodukt']['Produkt']['Elementarprodukt'])){
                            offer.keyFigures['Garantienieveau'] = action.data['Angebot']['Angebot']['Verkaufsprodukt']['Produkt']['Elementarprodukt'][0]['Erweiterung']['Garantieniveau']
                        } else {
                            offer.keyFigures['Garantienieveau'] = action.data['Angebot']['Angebot']['Verkaufsprodukt']['Produkt']['Elementarprodukt']['Erweiterung']['Garantieniveau']
                        }
                    } else { // Perspektiv
                        key = "Ges. Einmalzahlung bei Tod am Anfang des Vers.-Jahres"
                    }

                    monthlyPayment = timeseries[action.customerId][action.offerType][key].map((i, idx) => {
                        let p = 0
                        if (paymentfrequency === 6 ) {
                            p = amount
                        } else {
                            p += amount * (1+idx*12)
                        }
                        return {
                            x: i.x,
                            y: p,
                        }
                    })
                    timeseries[action.customerId][action.offerType]["monthlyPayment"] = monthlyPayment
                    tableMonthlyPayment = monthlyPayment.map(item => {
                        return {
                            "Art": "monthlyPayment",
                            "Betrag": item.y,
                            "Termin": item.x
                        }
                    })    
                    offer.timeSeries = {
                        ...timeseries
                    }
                    offer.tableTimeSeries = mergeTimeSeriesForTables([].concat(tableMonthlyPayment).concat(action.data.Angebot["Angebot"]["Verkaufsprodukt"]["Produkt"]["Verlauf"]["Verlaufseintrag"]))
        
                }
            }

            
            if (state.offers[action.customerId] === undefined) {
                state.offers[action.customerId] = {
                    [action.offerType]: offer,  
                }
            } else {
                state.offers[action.customerId][action.offerType] = offer
            }

            return state
            
        case offerTypes.REQUEST_CONTRACT:
            state = {
                ...state, 
                isFetching: true,
            }
            return state
        
        case offerTypes.ERROR_CONTRACT:

            state = {
                ...state,
                isFetching: false,
                ...action.response,
            }

            return state

        case offerTypes.RECEIVE_CONTRACT:
            state = {
                ...state, 
                isFetching: false,
            }
            state.contractSigning = action.data

            // for(var key of Object.keys(action.data.signing_urls)) {
            //     console.log(action.data.signing_urls[key])
            //     window.open(action.data.signing_urls[key], "_blank")
            // }
            return state
        

        default:
            return state
    }
}


const tilbodInitialState = {
    jsondata: {},
    isFetching: false,
    isGenerating: false,
    isSending: false,
    error: false,
    sendError: false,
    sendErrorList: []
}

export function tilbod(state=tilbodInitialState, action) {
    switch(action.type) {
        case offerTypes.REQUEST_GENERATE_CONTRACT_FILES:
            state = {
                ...state,
                isGenerating: true,
            }
            return state

        case offerTypes.RECEIVE_GENERATE_CONTRACT_FILES:
            state = {
                ...state,
                ...action.data,
                isGenerating: false,
            }
            return state

        case offerTypes.REQUEST_SEND_CONTRACT:
            state = {
                ...state,
                isSending: true,
            }
            return state
        
        case offerTypes.ERROR_SEND_CONTRACT:

            state = {
                ...state,
                isSending: false,
                sendError: true,
                sendErrorList: action.response.error_list
            }
            return state
            
        case offerTypes.RECEIVE_SEND_CONTRACT:
            state = {
                ...state, 
                isSending: false,
                ...action.data,
            }
            return state

        case offerTypes.REQUEST_TILBOD:
            state = {
                ...state,
                isFetching: true,
            }
            return state
                    
        case offerTypes.RECEIVE_TILBOD:
            state = {
                ...state, 
                isFetching: false,
                ...action.data,
            }
            return state

        case offerTypes.REQUEST_ADDITIONAL_ANSWERS:
            state = {
                ...state,
                isFetching: true,
            }
            return state
                    
        case offerTypes.RECEIVE_ADDITIONAL_ANSWERS:
            const { token, ...restData } = action.data;
            if (!token) {
                console.log(action.data);
                // Optionally log a warning or handle this case differently
                return state; // or handle as needed
            }
            return {
                ...state,
                isFetching: false,
                additionalQuestionsAnswers: {
                    ...(state.additionalQuestionsAnswers || {}),
                    [token]: restData
                }
            };
        case offerTypes.ERROR_TILBOD:
        case offerTypes.ERROR_ADDITIONAL_ANSWERS:

            state = {
                ...state,
                isFetching: false,
                error: true,
                errorMessage: action.response.message
            }
            return state

        default:
            return state

    }
}



const tilbodMultiInitialState = {
    isFetching: false,
    error: false,
    offers: [],
    agents: []
}

export function agentOffers(state=tilbodMultiInitialState, action) {
    switch(action.type) {

        case offerTypes.REQUEST_TILBOD_MULTI:
            state = {
                ...state,
                isFetching: true,
            }
            return state
        
        case offerTypes.ERROR_TILBOD_MULTI:

            state = {
                ...state,
                isFetching: false,
                error: true,
                errorMessage: action.response.message
            }
            return state
            
        case offerTypes.RECEIVE_TILBOD_MULTI:
            state = {
                ...state, 
                isFetching: false,
                offers: action.data,
                agents: [... new Set(action.data.map(o => o.agent_name))]
            }
            return state

        default:
            return state

    }
}

const tilbodCustomerMultiInitialState = {
    isFetching: false,
    error: false,
    offers: [],
    agents: []
}

export function customerOffers(state=tilbodCustomerMultiInitialState, action) {
    switch(action.type) {

        case offerTypes.REQUEST_TILBOD_MULTI:
            state = {
                ...state,
                isFetching: true,
            }
            return state
        
        case offerTypes.ERROR_TILBOD_MULTI:

            state = {
                ...state,
                isFetching: false,
                error: true,
                errorMessage: action.response.message
            }
            return state
            
        case offerTypes.RECEIVE_TILBOD_MULTI:
            state = {
                ...state, 
                isFetching: false,
                offers: action.data,
                agents: [... new Set(action.data.map(o => o.agent_name))]
            }
            return state

        default:
            return state

    }
}